import React, { PropsWithChildren } from 'react';
import { useAuthContext } from 'domain/auth/hooks/useAuthContext';
import { Navigate } from 'react-router';
import { UserRole } from 'types/auth';

function RequireAdmin({ children }: PropsWithChildren<unknown>) {
  const { userRole } = useAuthContext();

  return userRole === UserRole.ADMIN ? <>{children}</> : <Navigate to="/home" />;
}

export default RequireAdmin;
